var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10397 12.2539L14.6808 6.21381C14.836 6.07127 15.017 6 15.224 6C15.4309 6 15.612 6.07127 15.7672 6.21381C15.9224 6.35635 16 6.52573 16 6.72196C16 6.91819 15.9224 7.08733 15.7672 7.2294L8.64718 13.7862C8.49198 13.9287 8.31091 14 8.10397 14C7.89703 14 7.71596 13.9287 7.56075 13.7862L4.22385 10.7216C4.06865 10.5791 3.99415 10.4099 4.00036 10.2142C4.00657 10.0184 4.08753 9.84903 4.24325 9.70601C4.39898 9.563 4.58341 9.49173 4.79656 9.4922C5.00971 9.49268 5.19388 9.56395 5.34909 9.70601L8.10397 12.2539Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleCheck);
export default __webpack_public_path__ + "static/media/icon_circle_check.5ec315c7d73506d6e9ed9b67971d4645.svg";
export { ForwardRef as ReactComponent };